module.exports = __webpack_public_path__ + "static/media/polo-shirt.e0d8034f.png";